import { Plan, PlanTypes } from '../models/plan.model';
import { KinoSubscription } from '../models/kino-subscription.model';
import { SubscriptionPlan } from 'app/models/subscrition-plan.model';

export const calculateAnnualSavedPercentage = (plans: SubscriptionPlan[]): number => {
  const monthlyPlan: SubscriptionPlan = plans.find((p) => p.name === PlanTypes.Month);
  const yearlyPlan: SubscriptionPlan = plans.find((p) => p.name === PlanTypes.Year);

  const monthlyPlanCostPerYear: number = monthlyPlan.price * 12;
  const totalEconomy: number = monthlyPlanCostPerYear - yearlyPlan.price;

  return (totalEconomy / monthlyPlanCostPerYear) * 100;
};

export const isPlanAvailable = (
  plan: SubscriptionPlan,
  activeSubscription: KinoSubscription | null
) => {
  const planTypesArray: PlanTypes[] = [
    PlanTypes.Month,
    PlanTypes.Year,
    PlanTypes.Life,
  ];
  if (
    !activeSubscription ||
    !planTypesArray.includes(plan.name as PlanTypes) ||
    !!activeSubscription.familyOption?.externalAdminEmail
  ) {
    return true;
  }
  return (
    planTypesArray.indexOf(plan.name as PlanTypes) >
    planTypesArray.indexOf(activeSubscription.plan.name as PlanTypes)
  );
};
